import React, { useContext } from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import PostIdentButton from "../../../components/page-components/onboarding/postident-button";
import { AppContext } from "../direct-router";
import IVDrawer from "../../../components/template-components/iv-drawer";
import { Card, Text, Button, Dot, Spacer, Grid } from "@geist-ui/core";
import { Video, X } from "@geist-ui/icons";

export default function VideoIdent() {
  const app_context = useContext(AppContext);
  const [videoident_open, setVideoIdentOpen] = useState(false);
  const user = app_context.user;

  return (
    <Card 
      shadow={false} 
      style={{ 
        borderRadius: '16px', 
        border: '1px solid #EAEAEA', 
        boxShadow: 'none', 
        backgroundColor: '#FFFFFF',
        width: '100%',
        padding: 0
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'clamp(16px, 3vw, 24px)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Dot type="warning" style={{ transform: 'scale(1.2)' }} />
            <div>
              <Text b font="15px" style={{ margin: 0, display: 'block', lineHeight: '1.2' }}>Legitimation erforderlich</Text>
              <Text type="secondary" font="13px" style={{ margin: 0, marginTop: '4px', display: 'block', lineHeight: '1.4' }}>
                Schließen Sie Ihre Legitimation ab, um Investitionen zu finalisieren.
              </Text>
            </div>
          </div>
          <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-6 py-2 rounded-full bg-black text-white font-bold text-xs uppercase tracking-tight shadow-lg transition-all"
              onClick={() => setVideoIdentOpen(true)}
              style={{ minWidth: 'fit-content', height: 'fit-content' }}
          >
              Starten
          </motion.button>
      </div>

      <IVDrawer
        open={videoident_open}
        close={() => {
          setVideoIdentOpen(false);
        }}
      >
        <div style={{ padding: '40px', position: 'relative' }}>
          <div 
            onClick={() => setVideoIdentOpen(false)}
            style={{ 
              position: 'absolute', 
              top: '24px', 
              right: '24px', 
              cursor: 'pointer', 
              color: '#888',
              padding: '8px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease'
             }}
             onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
             onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <X size={20} />
          </div>
          <Text h3 style={{ fontWeight: 800, marginBottom: '8px', letterSpacing: '-0.02em', fontSize: '28px', fontFamily: '"Nunito Sans", sans-serif' }}>Videoidentifikation</Text>
          <Text p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', marginBottom: '40px', fontFamily: '"Nunito Sans", sans-serif' }}>
              Damit wir Ihre Investition akzeptieren können, müssen Sie das
              Legitimationsverfahren der Deutschen Post durchführen.
          </Text>
          
          <div style={{ display: 'grid', gap: '32px' }}>
            
            <div style={{ display: 'grid', gap: '24px' }}>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#000' }} />
                </div>
                <Text span style={{ fontSize: '16px', fontFamily: '"Nunito Sans", sans-serif', lineHeight: '1.5' }}>Der Vorgang dauert ca. <b>5-10</b> Minuten. Nach erfolgreichem Abschluss erhalten Sie eine E-Mail.</Text>
              </div>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#000' }} />
                </div>
                <Text span style={{ fontSize: '16px', fontFamily: '"Nunito Sans", sans-serif', lineHeight: '1.5' }}>Halten Sie bitte Ihren Ausweis oder Reisepass bereit.</Text>
              </div>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                     <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#000' }} />
                </div>
                <Text span style={{ fontSize: '16px', fontFamily: '"Nunito Sans", sans-serif', lineHeight: '1.5' }}>Wir empfehlen das Verfahren über die App der Deutschen Post durchzuführen.</Text>
              </div>
            </div>

            <Spacer h={1} />
            
            {user ? (
              <div style={{ width: '100%' }}>
                <PostIdentButton
                    firstName={user.natural_person.forename}
                    lastName={user.natural_person.surname}
                    email={user.communication.email}
                    city={user.natural_person.city}
                    country={user.natural_person.country}
                    phone={user.natural_person.phone}
                    street={user.natural_person.street}
                    title={user.natural_person.title}
                    uid={user.uid}
                    zip={user.natural_person.zip}
                />
              </div>
            ) : null}
          </div>
        </div>
      </IVDrawer>
    </Card>
  );
}
